import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "unitOption",
    "quantityTitle",
    "quantityHint",
    "selectedBadge",
    "singleQuantitySection",
    "singleQuantityLabel",
    "singleQuantityInput",
    "areaSection",
    "heightInput",
    "widthInput",
    "areaPreview"
  ]

  static values = {
    selectedCode: String,
    configs: Object,
    locale: String,
    areaUnitLabel: String
  }

  connect() {
    this.render()
  }

  change(event) {
    this.selectedCodeValue = event.target.dataset.unitCode || this.selectedUnitCode()
    this.render()
  }

  updateArea() {
    if (this.selectedUnitCode() == "cm2") {
      this.renderAreaPreview()
    }
  }

  selectedUnitCode() {
    return this.unitOptionTargets.find((option) => option.checked)?.dataset.unitCode || this.selectedCodeValue || "un"
  }

  render() {
    const code = this.selectedUnitCode()
    const config = this.configFor(code)
    const isAreaUnit = code == "cm2"

    this.selectedCodeValue = code
    this.quantityTitleTarget.textContent = config.title
    this.quantityHintTarget.textContent = config.hint
    this.selectedBadgeTarget.textContent = code

    this.singleQuantitySectionTarget.classList.toggle("hidden", isAreaUnit)
    this.areaSectionTarget.classList.toggle("hidden", !isAreaUnit)

    this.singleQuantityInputTarget.required = !isAreaUnit
    this.heightInputTarget.required = isAreaUnit
    this.widthInputTarget.required = isAreaUnit

    if (isAreaUnit) {
      this.renderAreaPreview()
      return
    }

    this.singleQuantityLabelTarget.textContent = config.singleLabel
    this.singleQuantityInputTarget.placeholder = config.placeholder
    this.singleQuantityInputTarget.step = config.step
    this.singleQuantityInputTarget.min = config.min
  }

  renderAreaPreview() {
    const height = this.parseNumber(this.heightInputTarget.value)
    const width = this.parseNumber(this.widthInputTarget.value)
    const area = height > 0 && width > 0 ? height * width : 0

    this.areaPreviewTarget.textContent = `${this.numberFormatter().format(area)} ${this.areaUnitLabelText()}`
  }

  parseNumber(value) {
    if (!value) return 0

    const parsed = Number.parseFloat(value.toString().replace(",", "."))
    return Number.isFinite(parsed) ? parsed : 0
  }

  numberFormatter() {
    return new Intl.NumberFormat(this.hasLocaleValue ? this.localeValue : "pt-BR", { maximumFractionDigits: 2 })
  }

  configFor(code) {
    const configs = this.hasConfigsValue ? this.configsValue : {}
    return configs[code] || configs.un || {}
  }

  areaUnitLabelText() {
    return this.hasAreaUnitLabelValue ? this.areaUnitLabelValue : "cm²"
  }
}
